import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import { useLocation } from "react-router-dom";
import businessImg from "../../assests/business-value.svg";
import "./BusinessValue.css";
import check from"../../assests/check-img.svg";

const BusinessValue = () => {
  const location = useLocation();

  // Path-based content (title + description)
  const content: Record<
    string,
    { heading: string; items: { title: string; description: string }[] }
  > = {
    "/IOT-services": {
      heading: "Business Value We Deliver",
      items: [
        {
          title: "Smarter Operations:",
          description:
            " Real-time insights and automation drive efficiency and accuracy.",
        },
        {
          title: "Reduced Costs:",
          description:
            " Minimized downtime, waste, and manual effort save resources.",
        },
        {
          title: "Enhanced Productivity:",
          description: " Autonomous systems streamline repetitive tasks.",
        },
        {
          title: "Future-Ready Innovation:",
          description:
            " Stay ahead with AI-enabled, connected, and self-learning systems.",
        },
        {
          title: "Competitive Edge:",
          description:
            " Intelligent automation gives your business speed, accuracy, and scalability.",
        },
      ],
    },
    "/Custom-Software": {
      heading: "Business Value We Deliver",
      items: [
        {
          title: "Faster Digital Transformation:",
          description: " Software that accelerates your business strategy",
        },
        {
          title: "Higher Engagement:",
          description:
            " Intuitive, interactive experiences that delight users. ",
        },
        {
          title: "Operational Efficiency:",
          description:
            " Streamlined workflows and optimized processes reduce costs. ",
        },
        {
          title: "Competitive Advantage:",
          description:
            " Unique solutions that differentiate your brand and build loyalty.",
        },
        {
          title: "Measurable Impact:",
          description:
            " Solutions designed to deliver tangible results and long-term growth. ",
        },
      ],
    },
    "/AI-ML-Solution": {
      heading: "Business Value We Deliver",
      items: [
        {
          title: "Autonomous Operations:",
          description:
            " Let AI agents act independently to save time and reduce errors.",
        },
        {
          title: "Smarter Decisions:",
          description: " Transform raw data into actionable insights.",
        },
        {
          title: "Operational Efficiency:",
          description: " Optimize workflows, reduce costs, and improve productivity.",
        },
        {
          title: "Enhanced Customer Engagement:",
          description:
            " Personalization powered by AI predictions and autonomous actions.",
        },
        {
          title: "Competitive Advantage:",
          description:
            " Stay ahead with proactive, intelligent systems that act on data.",
        },
      ],
    },
    "/Data-Management": {
      heading: "What Clients Gain ",
      items: [
        {
          title: "30–40% Faster Reporting",
          description: " through optimized pipelines. ",
        },
        {
          title: "99.9% Data Accuracy",
          description: " with advanced cleansing & enrichment. ",
        },
        {
          title: "60% Cost Reduction",
          description: " in data handling via automation.",
        },
        {
          title: "Full Compliance Readiness",
          description: " across multiple regulatory frameworks.",
        },
      ],
    },
  };

  // Pick content based on current path (default `/`)
    const pageContent = content[location.pathname];

  return (
  <div style={{display:"flex",justifyContent:"center"}}>
    <section className=" bg-light businessvalue-container">
      <Row className="align-items-center">
        {/* Left Content */}
        <Col lg={6} md={12} className="mb-4 mb-lg-0 text-start">
          <h2 className="mb-4 business-h2">{pageContent?.heading}</h2>
          <ul className="list-unstyled">
            {pageContent?.items?.map((item, index) => (
              <li key={index} className="mb-3 d-flex gap-3 align-items-start">
                <img src={check} alt="check" className="text-success" />
                <span className="business-span">
                  <span className="business-title">{item.title}</span>
                  <span className="business-description">{item.description}</span>
                </span>
              </li>
            ))}
          </ul>
        </Col>

        {/* Right Image */}
        <Col lg={6} md={12} className="text-end">
          <img
            src={businessImg}
            alt="Business Value"
            className="img-fluid"
            style={{ maxHeight: "400px" }}
          />
        </Col>
      </Row>
    </section>
    </div>
  );
};

export default BusinessValue;
